import { render, staticRenderFns } from "./_base-switch-custom.vue?vue&type=template&id=2c1c081b&scoped=true"
import script from "./_base-switch-custom.vue?vue&type=script&lang=js"
export * from "./_base-switch-custom.vue?vue&type=script&lang=js"
import style0 from "./_base-switch-custom.vue?vue&type=style&index=0&id=2c1c081b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c081b",
  null
  
)

export default component.exports